"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labels = void 0;
exports.labels = {
    system: {
        concur: "Concur",
        csv: "CSV",
    },
    masterType: {
        supplier: "取引先マスタ",
        customList: "カスタムリスト",
        hyperPaste: "ハイパーペースト更新",
    },
};
